import {
  Company,
  Organization,
  Channels,
  Sectors,
  Offices,
  CustomerType
} from 'constants/enums'
import type {
  Customer,
  CustomerApi,
  CustomersRequestData,
  CustomersRequestDataApi,
  CustomersResponseData,
  CustomersResponseDataApi
} from './types'
import { formatCnpj } from 'commons/utils/string'

export const toCustomer = (customerApi: CustomerApi): Customer => {
  return {
    id: customerApi.codigo,
    name: customerApi.nome,
    cnpj: customerApi.cnpj,
    cnpjFormatted: formatCnpj(customerApi.cnpj),
    stateTaxRegistration: customerApi.inscricaoEstatual,
    type: customerApi.tipo as CustomerType,
    commercialStructure: {
      idCompany: customerApi.estruturaComercial.codigoEmpresa as Company,
      idOrganization: customerApi.estruturaComercial.codigoOrganizacao as Organization,
      idMarket: customerApi.estruturaComercial.codigoCanal as Channels,
      idSector: customerApi.estruturaComercial.codigoSetor as Sectors,
      idOffice: customerApi.estruturaComercial.codigoEscritorio as Offices,
      idRegional: customerApi.estruturaComercial.codigoReginal,
      idZone: customerApi.estruturaComercial.codigoZona
    },
    address: {
      street: customerApi.enderecoCliente.endereco,
      number: customerApi.enderecoCliente.numero,
      complement: customerApi.enderecoCliente.complemento,
      district: customerApi.enderecoCliente.bairro,
      city: customerApi.enderecoCliente.cidade,
      state: customerApi.enderecoCliente.estado,
      addressFormatted: customerApi.enderecoCliente.enderecoFormatado
    }
  }
}

export const toCustomerApi = (customer: Customer) => {
  return {
    codigo: customer.id,
    nome: customer.name,
    cnpj: customer.cnpj,
    inscricaoEstatual: customer.stateTaxRegistration,
    tipo: customer.type as string,
    estruturaComercial: {
      codigoEmpresa: customer.commercialStructure.idCompany as string,
      codigoOrganizacao: customer.commercialStructure.idOrganization as string,
      codigoCanal: customer.commercialStructure.idMarket as string,
      codigoSetor: customer.commercialStructure.idSector as string,
      codigoEscritorio: customer.commercialStructure.idOffice as string,
      codigoReginal: customer.commercialStructure.idRegional,
      codigoZona: customer.commercialStructure.idZone
    },
    enderecoCliente: {
      endereco: customer.address.street,
      numero: customer.address.number,
      complemento: customer.address.complement,
      bairro: customer.address.district,
      cidade: customer.address.city,
      estado: customer.address.state,
      enderecoFormatado: customer.address.addressFormatted
    }
  }
}

export const toCustomersResponseData = (
  response: CustomersResponseDataApi
): CustomersResponseData => {
  const { data, pagination } = response

  const customers = data.map((customer) => {
    return toCustomer(customer)
  })

  return {
    pagination,
    data: customers
  }
}

export const toCustomersRequestDataApi = (
  body: CustomersRequestData
): CustomersRequestDataApi => {
  return {
    pesquisa: body.search,
    codigoCanal: body.commercialStructure?.idMarket ?? null,
    codigoSetor: body.commercialStructure?.idSector ?? null,
    codigoEscritorio: body.commercialStructure?.idOffice ?? null,
    codigoReginal: body.commercialStructure?.idRegional ?? null,
    codigoZona: body.commercialStructure?.idZone ?? null
  }
}
